import React from "react";
import {logAction} from "../../../../logging/logEvent";
import PortfolioCheckbox from "./PortfolioCheckbox";

const CloseAllCheckbox = ({allOpenPortfolios, closing, ideaActions}) => {
    const numberSelectedToClose = closing.selectedBucketIds ? closing.selectedBucketIds.length : 0;
    const allSelected = allOpenPortfolios.length === numberSelectedToClose;

    const onClick = () => {
        const selectAll = !allSelected;
        logAction({
            type: "SELECT_ALL_CLOSE_PORTFOLIOS_CHECKBOX_CLICKED",
            newValue: selectAll
        });
        ideaActions.selectAllBucketIdsToClose(selectAll);
    };

    return (<PortfolioCheckbox className="t-select-all-checkbox"
                               onClick={onClick}
                               checked={allSelected}/>);
};

export default CloseAllCheckbox;